import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledTabContainer = styled.div`
  display: flex;
  position: relative;
  height: 45px;
  margin-bottom: 12px;
  padding: 4px;
  border: 0.5px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 29px;
  background: #f5f7fb;
`

const StyledTab = styled.button`
  flex: 1;
  padding: 8px 0;
  border: none;
  border-radius: 33px;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  color: #000;
  z-index: 2;
`

const Handle = styled.div<{ $wrap: boolean }>`
  width: calc(50% - 8px);
  height: 36px;
  background-color: white;
  border-radius: 33px;
  position: absolute;
  left: ${({ $wrap }) => ($wrap ? '4px' : 'calc(50% + 4px)')};
  transition: left 0.3s ease;
  top: 4px;
  z-index: 1;
`

export type WrapTabType = 'wrap' | 'unwrap'

interface WrapTabsProps {
  activeTab: WrapTabType
  onChange: (tab: WrapTabType) => void
}

const WrapTabs: React.FC<WrapTabsProps> = ({ activeTab, onChange }) => {
  const { t } = useTranslation()

  const handleTabChange = (tab: WrapTabType) => {
    if (tab !== activeTab) {
      onChange(tab)
    }
  }

  return (
    <StyledTabContainer>
      <Handle $wrap={activeTab === 'wrap'} />
      <StyledTab onClick={() => handleTabChange('wrap')}>
        {t('lido_wrap_tab_title')}
      </StyledTab>
      <StyledTab onClick={() => handleTabChange('unwrap')}>
        {t('lido_unwrap_tab_title')}
      </StyledTab>
    </StyledTabContainer>
  )
}

export default WrapTabs
